import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ClientUserGroup {
  user_group_id: string | number
  user_group_name: string
  [key: string]: any
}

export interface ClientUserGroupsValue {
  client_id: string | number
  client_name: string
  user_groups: ClientUserGroup[]
}

interface ClientUserGroupsState {
  value: ClientUserGroupsValue | null
}

const initialState: ClientUserGroupsState = { value: null }

const clientUserGroupsSlice = createSlice({
  name: 'clientUserGroups',
  initialState,
  reducers: {
    setClientUserGroups(state, action: PayloadAction<ClientUserGroupsValue>) {
      state.value = action.payload
    },
    clearClientUserGroups(state) {
      state.value = null
    },
  },
})

export const { setClientUserGroups, clearClientUserGroups } = clientUserGroupsSlice.actions
export default clientUserGroupsSlice.reducer
export { initialState }
